/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 Accordion = (function() {
   function Accordion() {
     jQuery('.accordion.headings').each(function() {
       return jQuery(this).add(jQuery(this).next('.accordion.content')).wrapAll("<div class='accordion-wrapper'/>");
     });
     general_scroll_to_active_item = false;

     jQuery('.accordion.headings li').wrapInner('<div class="trigger"></div>');
     jQuery('.accordion-wrapper').each(function() {
       var accordion_content, accordion_heading;
       accordion_heading = jQuery(this).find('.accordion.headings > li');
       accordion_content = jQuery(this).find('.accordion.content > li');
       //accordion_heading.first().addClass('active');
       accordion_content.each(function(index) {
         var content;
         content = jQuery('<div class="content">' + jQuery(this).html() + '</div>');
         return content.appendTo(accordion_heading.eq(index));
       });
       accordion_content.remove();
       //jQuery(this).find('.content').first().show();
       return jQuery(this).find('.trigger').on("click", function() {
         if( $(this).parent().hasClass('active') ) {

           jQuery(this).find('.toggle-icon').text('+').removeClass('minus-sign').addClass('plus-sign');

           var panels, this_panel;
           panels = jQuery(this).closest(".accordion").find('.content');
           this_panel = jQuery(this).closest("li").find(".content");
           this_panel.slideUp(200);

           return jQuery(this).closest("li").removeClass("active");

         } else {
           jQuery('.toggle-icon').text('+').addClass('plus-sign').removeClass('minus-sign');
           jQuery(this).find('.toggle-icon').text('-').removeClass('plus-sign').addClass('minus-sign');

           var panels, this_panel;
           panels = jQuery(this).closest(".accordion").find('.content');
           this_panel = jQuery(this).closest("li").find(".content");
           panels.not(this_panel).slideUp(200);
           this_panel.slideDown(200, function() {
             if (general_scroll_to_active_item) {
               return jQuery('html, body').animate({
                 scrollTop: this_panel.offset().top - 100
               });
             }
           });
           jQuery(this).closest(".accordion").find("li").removeClass("active");
           return jQuery(this).closest("li").addClass("active");
         }
       });
     });
   }

   return Accordion;

 })();

if( document.getElementById('rotatingElement') ) {
  var element = document.getElementById('rotatingElement');
  var typedInitialConfig = JSON.parse(element.getAttribute('data-typed-options'));

  var typed = new Typed("#rotatingElement", {
    stringsElement: '#rotatingWords',
    typeSpeed: typedInitialConfig['typeSpeed'],
    backSpeed: typedInitialConfig['backSpeed'],
    backDelay: typedInitialConfig['backDelay'],
    startDelay: typedInitialConfig['startDelay'],
    loop: typedInitialConfig['loop'],
    fadeOut: typedInitialConfig['fadeOut'],
    showCursor: typedInitialConfig['showCursor'],
    cursorChar: typedInitialConfig['cursorChar']
  });
}

if( document.querySelector('.Instafeed') ) {
  function calcPhotoHeight() {
    document.querySelectorAll('.Instafeed.no-carousel a').forEach(function(elem){
      var width = elem.clientWidth - 30; // restar el padding
      elem.style.height = width + 'px';
    });
  }

  calcPhotoHeight();

  window.addEventListener('resize', calcPhotoHeight);
}

if( document.querySelector('.product-accordion') ) {

  function runWithJQuery(jQueryCode){
    if(window.jQuery)  jQueryCode();
    else{
      var script = document.createElement('script');
      document.head.appendChild(script);
      script.type = 'text/javascript';
      script.src = "//ajax.googleapis.com/ajax/libs/jquery/3.1.0/jquery.min.js";
      script.onload = jQueryCode;
    }
  }
  runWithJQuery(function jQueryCode(){
    new Accordion();
  })

}
